<template>
  <div class="content">
    <!--列表-->
    <div>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>出口车型管理</el-breadcrumb-item>
      </el-breadcrumb>
      <el-row type="flex" :gutter="20">
        <el-col :span="1.5">
          <el-button style="float: left" type="primary" @click="onAuditEnable(0)">批量上架</el-button>
        </el-col>
        <el-col :span="1.5">
          <el-button style="float: left" type="primary" @click="onAuditEnable(1)">批量下架</el-button>
        </el-col>
        <el-col :span="1.5">
          <el-button style="float: left" type="primary" @click="onAuditDelete">批量删除</el-button>
        </el-col>
        <el-col
          :span="1.5"
          v-if="$utils.checkPer('car-special-offer.store')"
        >
          <el-button style="float: left" type="primary" @click="addData"
            >新增</el-button>
        </el-col>
        
        <el-col :span="3">
          <el-input
            v-model="where.model_name"
            style="width: 200px"
            placeholder="车型名称"
            clearable
          ></el-input>
        </el-col>
        <el-col :span="10">
          <!-- :inputList.sync="row" -->
          <carSearch
          @increment="appAddCounter"
          :searchType="3"
        ></carSearch>
        </el-col>
        <el-col :span="1">
          <el-button type="primary" @click="index(where)">查询</el-button>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px">
        <el-table v-loading="loading" border :data="tableData" height="650" style="margin-bottom:5px" @selection-change="handleSelectionChange">
          <el-table-column fixed type="selection" width="55">
          </el-table-column>
          <el-table-column
            type="index"
            fixed
            label="序号"
            width="50"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="get_brand.brand_name"
            label="品牌名称"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="get_series.series_name"
            label="车系名称"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="get_model.model_name"
            label="车型名称"
            align="center"
            width="200"
          >
          </el-table-column>
          <el-table-column
            prop="special_price_true"
            align="center"
            label="优惠成交价"
          >
          </el-table-column>
          <el-table-column
            prop="special_discount_max"
            align="center"
            label="降价幅度"
          >
          </el-table-column>
          <el-table-column
            prop="special_case"
            align="center"
            label="车源类型"
          >
          </el-table-column>
          <el-table-column
            prop="cityid"
            align="center"
            label="车源所在地"
          >
            <template slot-scope="scope">{{scope.row.get_city?scope.row.get_city.name:'暂未设置'}}</template>
          </el-table-column>
          <el-table-column
            prop="special_source_point"
            align="center"
            label="车源自提点"
          >
          </el-table-column>
          <el-table-column
            prop="stock_quantity"
            align="center"
            label="车辆库存数量"
          >
          </el-table-column>
          <el-table-column
            prop="cityid"
            align="center"
            label="销售"
          >
            <template slot-scope="scope">{{scope.row.get_user?scope.row.get_user.name:'暂未设置'}}</template>
          </el-table-column>
          <el-table-column
            prop="sort"
            align="center"
            label="排序"
          >
          </el-table-column>
          <!-- <el-table-column
            prop="remark"
            align="center"
            label="备注"
          >
          </el-table-column> -->
          <!-- 0: 默认(启用) 1：禁用 -->
          <el-table-column
            prop="enable_status"
            align="center"
            label="上架状态"
          >
          <template slot-scope="scope">
            <el-tag type="danger" v-if="scope.row.enable_status == 1">未上架</el-tag>
            <el-tag type="success" v-else>已上架</el-tag>
          </template>
          </el-table-column>
          <!-- 0: 默认(审核中) 1：成功 2: 拒绝 3: 失败 -->
          <el-table-column
            prop="audit_type"
            align="center"
            label="审核状态"
          >
          <template slot-scope="scope">
            <el-tag v-if="scope.row.audit_type == 0">待审核</el-tag>
            <el-tag type="success" v-if="scope.row.audit_type == 1">审核成功</el-tag>
            <el-tag type="danger" v-if="scope.row.audit_type == 2">审核驳回</el-tag>
          </template>
          </el-table-column>
          <el-table-column prop="created_at" align="center" label="时间">
            <template slot-scope="scope">{{$utils.isDate(scope.row.created_at)}}</template>
          </el-table-column>
          <el-table-column
            prop="address"
            align="center"
            label="操作"
            width="200"
          >
            <template slot-scope="scope">
              <el-button
                size="small"
                v-if="$utils.checkPer('car-special-offer.store')"
                @click="editMessage(scope.row)"
                type="primary" 
                plain
                >修改</el-button
              >
              <el-button
                size="small"
                v-if="$utils.checkPer('car-special-offer.store')"
                @click="delMessage(scope.row)"
                type="danger"
                plain
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="index(where)"
          :current-page.sync="where.page"
          :page-size="where.pagesize"
          :page-sizes="[10, 20, 50, 100]"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          background
        >
        </el-pagination>
      </el-row>
    </div>
    <!-- 添加，编辑 -->
    <el-dialog
      title="出口车型"
      :visible.sync="dialogVisible"
      width="50%"
      :before-close="handleClose"
      v-if="dialogVisible"
    >
      <myForm
        @emincarofer="onemincarofer"
        :row="updatedList"
        :edit="isupdata"
      ></myForm>
    </el-dialog>
  </div>
</template>

<script>
import carSearch from "../../components/car-search/car-search";
import myForm from "./form";
import {
  car_special_offer,
  addcar_special_offer,
  modifycar_special_offer,
  delcar_special_offer,
  addcar_special_offer_auditEnable,
  addcar_special_offer_auditDelete
} from "../../api/api";
export default {
  name: "car-special-offer",
  components: { myForm,carSearch },
  data() {
    return {
      tableData: [],
      keyword: [],
      loading: false,
      where: {
        // modelid: "",
        model_name: "",
        page: 1,
        pagesize: 10,
      },
      total: 0,
      dialogVisible: false,
      isupdata: false,
      isupdataid: 0,
      updatedList: "",
      userInfo: "", // 用户信息
      multipleSelection: [], // 多选
    };
  },
  mounted() {
    this.userInfo = JSON.parse(window.localStorage.getItem("user"));
    this.where.userid = this.userInfo.id == 1 ? '':this.userInfo.id;
    this.getList();
  },
  methods: {
    appAddCounter: function (e) {
      console.log("子组件传的值：",e);
      this.where.brandid = e["brandid"];
      if (e["seriesid"])
        this.where.seriesid = e["seriesid"] ? e["seriesid"] : "";
      if (e["modelid"]) this.where.modelid = e["modelid"] ? e["modelid"] : "";
    },
    async getList() {
      this.loading = true;
      await car_special_offer(this.where).then((msg) => {
        let { data } = msg;
        data = JSON.parse(data).data;
        this.total = data.total;
        this.tableData = data.data;
        this.loading = false;
      });
    },
    addData() {
      this.dialogVisible = true;
    },
    //
    async onemincarofer(obj) {
      if (obj.form) {
        if (this.isupdata == false) {
          await addcar_special_offer(obj.form).then((msg) => {
            let { data } = msg;
            data = JSON.parse(data);
            if (data.code == 200) {
              this.$message.success(data.msg);
            } else {
              this.$message.error(data.msg);
            }
          });
        }
        if (this.isupdata == true) {
          await modifycar_special_offer(this.isupdataid, obj.form).then((msg) => {
            let { data } = msg;
            data = JSON.parse(data);
            if (data.code == 200) {
              this.$message.success(data.msg);
            } else {
              this.$message.error(data.msg);
            }
          });
        }
      }
      this.isupdata = false;
      this.isupdataid = 0;
      this.updatedList = "";
      this.dialogVisible = false;
      this.getList();
    },
    editMessage(scope) {
      this.dialogVisible = true;
      this.isupdataid = scope.id;
      this.isupdata = true;
      this.updatedList = scope;
    },
    delMessage(scope) {
      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delcar_special_offer(scope.id).then((msg) => {
            let { data } = msg;
            data = JSON.parse(data);
            if (data.code == 200) {
              this.getList();
              this.$message.success(data.msg);
            } else {
              this.$message.error(data.msg);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    handleSizeChange(val) {
      this.where.pagesize = val;
      this.getList();
    },
    index(e) {
      console.log(this.where);
      this.where = e;
      this.getList();
    },
    handleClose() {
      this.dialogVisible = false;
    },
    // 批量选中
    handleSelectionChange(val){
      this.multipleSelection = val;
    },
    // 批量上下架
    async onAuditEnable(enable_status) {
      if(!this.multipleSelection.length) {
        this.$message.error("请选择数据进行处理");
        return;
      }
      const auditObj = {}
      const ids = this.multipleSelection.map((item)=> item.id);
      auditObj.ids = ids;
      auditObj.enable_status = enable_status;

      await addcar_special_offer_auditEnable(auditObj).then((msg) => {
        let { data } = msg;
        data = JSON.parse(data);
        if (data.code == 200) {
          this.$message.success(data.msg);
          this.getList();
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    // 批量删除
    async onAuditDelete() {
      if(!this.multipleSelection.length) {
        this.$message.error("请选择数据进行处理");
        return;
      }
      const auditObj = {}
      const ids = this.multipleSelection.map((item)=> item.id);
      auditObj.ids = ids;

      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async() => {
          await addcar_special_offer_auditDelete(auditObj).then((msg) => {
            let { data } = msg;
            data = JSON.parse(data);
            if (data.code == 200) {
              this.$message.success(data.msg);
              this.getList();
            } else {
              this.$message.error(data.msg);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
  },
  filters: {
    getImg: function (value) {
      if (value == "[]") return "";
      let res = JSON.parse(value);
      let url = window.location.origin + "/" + res[0].response.path;
      return url;
    },
    getText: function (value) {
      if (!value || value == "") return "";
      let res_json = JSON.parse(value);
      let res = "";
      for (var i = 0; i < res_json.length; i++) {
        res += i + 1 + ":" + res_json[i] + "\r\n";
      }
      return res;
    },
  },
};
</script>

<style scoped lang="scss">
.el-col-3 {
  width: 210px;
}
.el-col-1 {
  width: 68px;
}
.el-breadcrumb {
  margin-bottom: 15px;
}
</style>

